import script from "./AddressCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressCard.vue?vue&type=script&setup=true&lang=js"

import "./AddressCard.vue?vue&type=style&index=0&id=76212aaa&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76212aaa"]])

export default __exports__